import { useEffect, useState } from "react";
import maersk from "../../assets/images/client-logo/maersk.webp";
import newHorizon from "../../assets/images/client-logo/NewHorizons.png";
import nbg from "../../assets/images/client-logo/nbg.png";
import anaenterprises from "../../assets/images/client-logo/anaenterprise.png";
import beacon from "../../assets/images/client-logo/beacon 1.png";
import cse from "../../assets/images/client-logo/CSE.png";
import planetDepos from "../../assets/images/client-logo/PlanetDeops.png";
import cirka from "../../assets/images/client-logo/cirka.png";
import fuelCell from "../../assets/images/client-logo/Fuelcell.jpeg";
import gpc from "../../assets/images/client-logo/gpc 1.png";
import goldenState from "../../assets/images/client-logo/golden 1.png";
import greenLight from "../../assets/images/client-logo/Greenlight.png";
import qbg from "../../assets/images/client-logo/Qbg.jpg";
import premierFamilyMedical from "../../assets/images/client-logo/Premier-Family-Medical.png";
import thornwell from "../../assets/images/client-logo/Thornwell.png";
import vetorial from "../../assets/images/client-logo/Vetorial.png";
import westFieldBank from "../../assets/images/client-logo/WestfieldBank.jpg";
import verdant from "../../assets/images/client-logo/Verdant.jpg";
import sunshine from "../../assets/images/client-logo/Sunshine.png";
import digital from "../../assets/images/client-logo/digital 1.png";
import spero from "../../assets/images/client-logo/Spero.webp";
import dyedur from "../../assets/images/client-logo/dye-dur 1.png";
import solidCard from "../../assets/images/client-logo/Solidcard.png";
import csg from "../../assets/images/client-logo/csg-bb 1.png";
import deepHaven from "../../assets/images/client-logo/Deephaven.png";
import copperSmith from "../../assets/images/client-logo/CopperSmith.jpeg";
import acilAllen from "../../assets/images/client-logo/AcilAllen.png";
import themis from "../../assets/images/client-logo/Themis.png";
import futures from "../../assets/images/client-logo/futures.png";
import housing from "../../assets/images/client-logo/HousingForward.png";
import prospecta from "../../assets/images/client-logo/prospect 1.png";
import pulman from "../../assets/images/client-logo/Pulman.png";
import bip from "../../assets/images/client-logo/bipsolutions.jpg";
import steelBlue from "../../assets/images/client-logo/SteelBlue.png";
import ingleside from "../../assets/images/client-logo/ingleside 1.png";
import inkomati from "../../assets/images/client-logo/Inkomati.png";
import integrityLocum from "../../assets/images/client-logo/IntegrityLocums.jpg";
import synergi from "../../assets/images/client-logo/synergi.jpeg";
import kolos from "../../assets/images/client-logo/kolos 1.png";
import martinelli from "../../assets/images/client-logo/martinell 1.png";
import aunovis from "../../assets/images/client-logo/Aunovis.png";
import metsi from "../../assets/images/metsi.png";
import tsv from "../../assets/images/client-logo/TSV.jpeg";
import oea from "../../assets/images/client-logo/oea 1.png";
import plantinnov from "../../assets/images/client-logo/plant-innov 1.png";
import qps from "../../assets/images/client-logo/QPS.png";
import racing from "../../assets/images/client-logo/Racing.png";
import asgard from "../../assets/images/asgard.png";
import freshDirect from "../../assets/images/client-logo/Freshdirect.jpeg";
import resiMax from "../../assets/images/client-logo/resimax 1.png";
import seedCompany from "../../assets/images/client-logo/SeedCompany.png";
import colorado from "../../assets/images/client-logo/Colorado.png";
import susquehanna from "../../assets/images/client-logo/susquehanna.png";
import em from "../../assets/images/client-logo/em.png";
import fsi from "../../assets/images/client-logo/fsi.png";

import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

function CustomersList() {
  // register();
  useEffect(() => {}, []);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    // slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 1000,
    cssEase: "linear",
  };

  return (
    <>
      <section className="cleint-logo">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-12 ">
              <h2 className="align-items-center text-center">
                Some Of Our happy customers
              </h2>
            </div>
            <div className="col">
              <Swiper
                // install Swiper modules
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={50}
                // slidesPerView={6}
                freeMode={true}
                // freeModeMomentum={false}
                allowTouchMove={false}
                loop={true}
                autoplay={{
                  delay: 0,
                  disableOnInteraction: true,
                }}
                speed={1000}
                breakpoints={{
                  100: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  320: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  480: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  640: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                  1000: {
                    slidesPerView: 6,
                    spaceBetween: 40,
                  },
                }}
                // navigation
                // pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                // onSwiper={(swiper: any) => console.log(swiper)}
                // onSlideChange={() => console.log("slide change")}
              >
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={maersk} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={newHorizon} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={nbg} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={anaenterprises} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={beacon} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={cse} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={planetDepos} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={cirka} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={fuelCell} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={gpc} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={goldenState} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={greenLight} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={qbg} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={premierFamilyMedical} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={thornwell} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={vetorial} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={westFieldBank} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={verdant} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={sunshine} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={digital} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={spero} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={dyedur} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={solidCard} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={csg} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={deepHaven} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={copperSmith} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={acilAllen} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={themis} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={futures} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={housing} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={asgard} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={prospecta} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={pulman} alt="" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            <div className="col">
              <Swiper // install Swiper modules
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={50}
                // slidesPerView={6}
                freeMode={true}
                allowTouchMove={false}
                loop={true}
                autoplay={{
                  delay: 0,
                  disableOnInteraction: true,
                }}
                speed={1000}
                breakpoints={{
                  100: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  320: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  480: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  640: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                  1000: {
                    slidesPerView: 6,
                    spaceBetween: 40,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={bip} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img src={steelBlue} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={ingleside}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={inkomati} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={integrityLocum}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={synergi} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={kolos} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={martinelli}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={aunovis} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={metsi} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={tsv} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={oea} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={plantinnov}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={qps} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={racing} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={freshDirect}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={resiMax} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={seedCompany}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={colorado} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img
                      className="client-logo-Square"
                      src={susquehanna}
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={em} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logos-item">
                    <img className="client-logo-Square" src={fsi} alt="" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CustomersList;
